import { Component, OnInit, Input } from '@angular/core';
import {
  Area,
  AreaProperty,
  DefaultAreas
} from '@app/shared/models/area';
import * as _ from 'lodash-es';
import { TranslateService } from '@ngx-translate/core';
import { CaseService, CaseUriBuilderParams } from '@app/core/services/case.service';
import { Case } from '@app/shared/models/case';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { UpdateComponent } from '@app/shared/components/base/update.component';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { DamageAreaSelector } from '@app/shared/models/damage-area-selector';
import { VehicleDamageMeta, VehicleDamageMetaContainer } from '@app/shared/models/vehicle-damage-meta';

@Component({
  selector: 'damage-area-selector',
  templateUrl: './damage-area-selector.component.html',
  styleUrls: ['./damage-area-selector.component.scss']
})
export class DamageAreaSelectorComponent extends UpdateComponent implements OnInit {

  public static readonly translations = {
    TYPE_BICYCLE: marker(`damage-area-selector.vehicle.type.BICYCLE`),
    TYPE_BUS: marker(`damage-area-selector.vehicle.type.BUS`),
    TYPE_BOAT: marker(`damage-area-selector.vehicle.type.BOAT`),
    TYPE_CARAVAN: marker(`damage-area-selector.vehicle.type.CARAVAN`),
    TYPE_MOTORCARAVAN: marker(`damage-area-selector.vehicle.type.MOTORCARAVAN`),
    TYPE_FORKLIFT: marker(`damage-area-selector.vehicle.type.FORKLIFT`),
    TYPE_MOTORCYCLE: marker(`damage-area-selector.vehicle.type.MOTORCYCLE`),
    TYPE_PASSENGERCAR: marker(`damage-area-selector.vehicle.type.PASSENGERCAR`),
    TYPE_TIPPER: marker(`damage-area-selector.vehicle.type.TIPPER`),
    TYPE_TRACTOR: marker(`damage-area-selector.vehicle.type.TRACTOR`),
    TYPE_TRUCK: marker(`damage-area-selector.vehicle.type.TRUCK`),
    TYPE_VAN: marker(`damage-area-selector.vehicle.type.VAN`),

    COMBI: marker(`damage-area-selector.vehicle.COMBI`),
    COMPACT_CAR_3DOORS: marker(`damage-area-selector.vehicle.COMPACT_CAR_3DOORS`),
    COMPACT_CAR_5DOORS: marker(`damage-area-selector.vehicle.COMPACT_CAR_5DOORS`),
    COUPE: marker(`damage-area-selector.vehicle.COUPE`),
    DELIVERY_VAN: marker(`damage-area-selector.vehicle.DELIVERY_VAN`),
    LIMOUSINE: marker(`damage-area-selector.vehicle.LIMOUSINE`),
    MINIBUS: marker(`damage-area-selector.vehicle.MINIBUS`),
    PICKUP: marker(`damage-area-selector.vehicle.PICKUP`),
    SPORTSCAR: marker(`damage-area-selector.vehicle.SPORTSCAR`),
    SUV: marker(`damage-area-selector.vehicle.SUV`),
    VAN: marker(`damage-area-selector.vehicle.VAN`),
    CHOPPER: marker(`damage-area-selector.vehicle.CHOPPER`),
    ENDURO: marker(`damage-area-selector.vehicle.ENDURO`),
    SCOOTER: marker(`damage-area-selector.vehicle.SCOOTER`),
    SPORTLER: marker(`damage-area-selector.vehicle.SPORTLER`),
    VINTAGE: marker(`damage-area-selector.vehicle.VINTAGE`),
    TRANSPORTER_CUBICLE: marker(`damage-area-selector.vehicle.TRANSPORTER_CUBICLE`),
    TRANSPORTER_PLATFORM: marker(`damage-area-selector.vehicle.TRANSPORTER_PLATFORM`),
    CUBICLE: marker(`damage-area-selector.vehicle.CUBICLE`),
    PLATFORM: marker(`damage-area-selector.vehicle.PLATFORM`),
    SEMI_TRAILER2AXLES: marker(`damage-area-selector.vehicle.SEMI_TRAILER2AXLES`),
    SEMI_TRAILER3AXLES: marker(`damage-area-selector.vehicle.SEMI_TRAILER3AXLES`),
    TANKER: marker(`damage-area-selector.vehicle.TANKER`),
    TRAILER: marker(`damage-area-selector.vehicle.TRAILER`),
    CAMPER: marker(`damage-area-selector.vehicle.CAMPER`),
    MOTOR_CARAVAN: marker(`damage-area-selector.vehicle.MOTOR_CARAVAN`),
    TRACTOR: marker(`damage-area-selector.vehicle.TRACTOR`),
    FIXED_FLATBED_LATTICE: marker(`damage-area-selector.vehicle.FIXED_FLATBED_LATTICE`),
    TIPPER: marker(`damage-area-selector.vehicle.TIPPER`),
    BICYCLE_OLD: marker(`damage-area-selector.vehicle.BICYCLE_OLD`),
    BICYCLE_SPORT: marker(`damage-area-selector.vehicle.BICYCLE_SPORT`),
    ARTICULATED_BUS: marker(`damage-area-selector.vehicle.ARTICULATED_BUS`),
    CITYBUS: marker(`damage-area-selector.vehicle.CITYBUS`),
    TOURING_BUS: marker(`damage-area-selector.vehicle.TOURING_BUS`),
    FIXED_FLATBED_PLAN: marker(`damage-area-selector.vehicle.FIXED_FLATBED_PLAN`),
    FIXED_FLATBED_LATTICE_COMPLETE: marker(`damage-area-selector.vehicle.FIXED_FLATBED_LATTICE_COMPLETE`),
    FIXED_FLATBED_PLAN_COMPLETE: marker(`damage-area-selector.vehicle.FIXED_FLATBED_PLAN_COMPLETE`),
    AIRCRAFT_CARRIER: marker(`damage-area-selector.vehicle.AIRCRAFT_CARRIER`),
    CANOE: marker(`damage-area-selector.vehicle.CANOE`),
    COASTGUARD: marker(`damage-area-selector.vehicle.COASTGUARD`),
    CONTAINER_SHIP: marker(`damage-area-selector.vehicle.CONTAINER_SHIP`),
    CRUISE_SHIP: marker(`damage-area-selector.vehicle.CRUISE_SHIP`),
    DINGHY: marker(`damage-area-selector.vehicle.DINGHY`),
    LOLO: marker(`damage-area-selector.vehicle.LOLO`),
    LOPAX: marker(`damage-area-selector.vehicle.LOPAX`),
    MOTOR_YACHT_1: marker(`damage-area-selector.vehicle.MOTOR_YACHT_1`),
    MOTOR_YACHT_2: marker(`damage-area-selector.vehicle.MOTOR_YACHT_2`),
    MOTOR_YACHT_3: marker(`damage-area-selector.vehicle.MOTOR_YACHT_3`),
    ROWING_BOAT: marker(`damage-area-selector.vehicle.ROWING_BOAT`),
    YACHT: marker(`damage-area-selector.vehicle.YACHT`),
    FORKLIFT: marker('damage-area-selector.vehicle.FORKLIFT'),
    TRAILER_3AXLE_CLOSED: marker('damage-area-selector.vehicle.TRAILER_3AXLE_CLOSED'),
    TRAILER_3AXLE_OPEN: marker('damage-area-selector.vehicle.TRAILER_3AXLE_OPEN'),
    TRIKE_1WHEEL_FRONT: marker('damage-area-selector.vehicle.FORKTRIKE_1WHEEL_FRONTLIFT'),
    TRIKE_2WHEEL_FRONT: marker('damage-area-selector.vehicle.TRIKE_2WHEEL_FRONT'),
    QUAD: marker('damage-area-selector.vehicle.QUAD')
  };

  @Input()
  public case: Case;

  private readonly additional = ['area_underbody', 'area_interior'];
  private readonly elements = ['fire', 'water'];

  private defaultAreas: DefaultAreas;
  public das: DamageAreaSelector;

  get area_all(): boolean {
    return this.case.vehicle.damage.area_all;
  }

  set area_all(checked: boolean) {
    this.toggleSelectAll(checked);
  }

  get area_underbody(): boolean {
    return this.case.vehicle.damage.area_underbody;
  }

  set area_underbody(checked: boolean) {
    this.case.vehicle.damage.area_underbody = checked;
    this.sendAreaUpdates('area_underbody', checked);
  }

  get area_interior(): boolean {
    return this.case.vehicle.damage.area_interior;
  }

  set area_interior(checked: boolean) {
    this.case.vehicle.damage.area_interior = checked;
    this.sendAreaUpdates('area_interior', checked);
  }

  get fire(): boolean {
    return this.case.vehicle.damage.fire;
  }

  set fire(checked: boolean) {
    this.case.vehicle.damage.fire = checked;
    this.sendAreaUpdates('fire', checked);
  }

  get water(): boolean {
    return this.case.vehicle.damage.water;
  }

  set water(checked: boolean) {
    this.case.vehicle.damage.water = checked;
    this.sendAreaUpdates('water', checked);
  }

  constructor(protected translateService: TranslateService, protected caseService: CaseService) {
    super();
  }

  public ngOnInit() {
    this.defaultAreas = {
      area_front_right:  {code: 'area_front_right', width: '30%', height: '30%', order: 3},
      area_center_right: {code: 'area_center_right', width: '40%', height: '30%', order: 4},
      area_rear_right:   {code: 'area_rear_right', width: '30%', height: '30%', order: 5},
      area_front_center: {code: 'area_front_center', width: '30%', height: '40%', order: 2},
      area_roof:         {code: 'area_roof', width: '40%', height: '40%', order: 9},
      area_rear_center:  {code: 'area_rear_center', width: '30%', height: '40%', order: 6},
      area_front_left:   {code: 'area_front_left', width: '30%', height: '30%', order: 1},
      area_center_left:  {code: 'area_center_left', width: '40%', height: '30%', order: 8},
      area_rear_left:    {code: 'area_rear_left', width: '30%', height: '30%', order: 7},
    };

    const uriBuilderParams = new CaseUriBuilderParams(this.case);
    this.caseService.getDamageMetaData(uriBuilderParams)
                    .subscribe((result) => {

      const areas = [];

      _.forEach(this.defaultAreas, (areaData: AreaProperty) => {
          areas.push(new Area(areaData));
      });

      this.das = new DamageAreaSelector(areas);

      const arr = result.getAsArray();
      _.forEach(arr, (vehicleDamageMetaContainer: VehicleDamageMetaContainer) => {
        vehicleDamageMetaContainer.type_translated = this.translateService.instant(vehicleDamageMetaContainer.translationCode);

        _.forEach(vehicleDamageMetaContainer.meta, (vehicleDamageMeta: VehicleDamageMeta) => {
          vehicleDamageMeta.graphic_key_translated = this.translateService.instant(vehicleDamageMeta.translationCode);
        });

        this.das.add(vehicleDamageMetaContainer);
      });

      this.das.sortVehicleDamageMeta();
      this.setSelection();

    }, err => this.handleError(err));
  }

  private setSelection(): void {
    if (this.case.vehicle.damage.graphic_key) {
      this.das.setSelectedVehicle(this.case.vehicle.damage.graphic_key);
      this.das.setSelectedAreas(this.case.vehicle.damage);
    } else {
      this.selectVehicleMeta('COMBI');
    }
  }

  private sendAreaUpdates(code: string, value: boolean, patches?: OpData[]): void {
    if (!patches) {
      patches = [];
    }

    if ((this.area_all && value === false && this.elements.indexOf(code) === -1) ||
        (!this.area_all && value === true && this.areaAllNeedsSelecting())) {
      this.case.vehicle.damage.area_all = value;
      patches.push({
        op: OP.replace,
        path: `vehicle/damage/area_all`,
        value: this.case.vehicle.damage.area_all
      });
    }

    patches.push({
      op: OP.replace,
      path: `vehicle/damage/${code}`,
      value: value
    });

    patches.push({
      op: OP.replace,
      path: `vehicle/damage/area_description`,
      value: this.createAreaDescription()
    });

    this.onMultiUpdate(patches);
  }

  private toggleSelectAll(toggleValue: boolean): void {
    this.case.vehicle.damage.area_all = toggleValue;

    const opData = this.das.toggleAllAreasSelected(toggleValue);

    this.case.vehicle.damage.area_interior = toggleValue;

    opData.push({
      op: OP.replace,
      path: `vehicle/damage/area_interior`,
      value: this.case.vehicle.damage.area_interior
    });

    this.case.vehicle.damage.area_underbody = toggleValue;

    opData.push({
      op: OP.replace,
      path: `vehicle/damage/area_underbody`,
      value: this.case.vehicle.damage.area_underbody
    });

    this.sendAreaUpdates('area_all', toggleValue, opData);
  }

  private areaAllNeedsSelecting(): boolean {
    if (!this.area_all) {

      if (!this.das.allAreasSelected()) {
        return false;
      }

      _.forEach(this.additional, area => {
        if (!this.case.vehicle.damage[area]) {
          return false;
        }
      });

      return true;
    }
  }

  public selectVehicleMeta(code: string): void {
    this.das.setSelectedVehicle(code);

    const opData = [];

    opData.push({
      op: OP.replace,
      path: `vehicle/damage/graphic_key`,
      value: this.das.selectedVehicleMeta.graphic_key
    });

    opData.push({
      op: OP.replace,
      path: `vehicle/damage/graphic_name`,
      value: this.das.selectedVehicleMeta.graphic_key_translated
    });

    this.onMultiUpdate(opData);
  }

  public toggleArea(code: string): void {
    const newSelection = this.das.toggleAreaSelected(code);
    this.sendAreaUpdates(code, newSelection);
  }

  private createAreaDescription(): string {
    let translated = '';

    translated = this.codeArrayToString(translated, this.elements);

    if (this.case.vehicle.damage.area_all) {
      translated = this.addTranslatedToDamageArea(translated, `damage.area_all`);
    } else {
      const selectedFromImage = _.sortBy(this.das.getSelectedAreas(), (area) => area.order);

      for (let i = 0; i < selectedFromImage.length; i++) {
        translated = this.addTranslatedToDamageArea(translated, `damage.${selectedFromImage[i].code}`);
      }

      translated = this.codeArrayToString(translated, this.additional);
    }

    return translated;
  }

  private codeArrayToString(currentString: string, codeArray: string[]): string {
    for (let i = 0; i < codeArray.length; i++) {
      const code = codeArray[i];
      if (this.case.vehicle.damage[code]) {
        currentString = this.addTranslatedToDamageArea(currentString, `damage.${code}`);
      }
    }

    return currentString;
  }

  private addTranslatedToDamageArea(currentString: string, transCode: string): string {
    if (currentString) {
      currentString += ', ';
    }

    currentString += this.translateService.instant(transCode);
    return currentString;
  }
}
